module.exports = __webpack_public_path__ + "static/media/bts_veld_170806_008_small.af2ec94c.jpg";